// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__SgAgv","iconWrapper":"styles_iconWrapper__ldftT","button":"styles_button__SzaNN"};